// extracted by mini-css-extract-plugin
export default {"footer":"footer__MjFhN","isPostAuthNav3":"isPostAuthNav3__ZjJjM","postAuthNav3PageWrapper":"postAuthNav3PageWrapper__M2NlY"};